import { type ReactNode } from 'react';

interface SectionTitleProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  sub?: ReactNode;
  action?: ReactNode;
  align?: 'left' | 'center';
}

export function SectionTitle({ eyebrow, title, sub, action, align = 'left' }: SectionTitleProps) {
  return (
    <div style={{ textAlign: align, marginBottom: 24 }}>
      {eyebrow && (
        <div style={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '0.16em',
          textTransform: 'uppercase',
          color: 'var(--accent)',
          marginBottom: 12,
        }}>
          {eyebrow}
        </div>
      )}
      <h2 className="h-display" style={{ margin: 0, fontSize: 40, color: 'var(--ink)' }}>{title}</h2>
      {sub && (
        <p style={{
          marginTop: 12,
          color: 'var(--ink-3)',
          fontSize: 16,
          lineHeight: 1.55,
          maxWidth: 560,
        }}>
          {sub}
        </p>
      )}
      {action}
    </div>
  );
}
